import { COLLECTION_FOCUS_GROUP_NAME } from "@/entities/form-metadata";

export const USER_COUNTRY_LIMIT = {
    "5544": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Australian,
        locationGpids: ["5027"],
    },
    "5543": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Canada,
        locationGpids: ["3243"],
    },
    "5538": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.UnitedKingdom,
        locationGpids: ["3257", "3250"],
    },
    "5547": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.French,
        locationGpids: ["5087"],
    },
    "5545": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.German,
        locationGpids: ["3253"],
    },
    "5823": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Irish,
        locationGpids: ["3257", "3250"],
    },
    "5546": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Italian,
        locationGpids: ["5118"],
    },
    "5565": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Mexico,
        locationGpids: ["3255"],
    },
    "5821": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Netherlands,
        locationGpids: ["5163"],
    },
    "5824": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Norway,
        locationGpids: ["5173"],
    },
    "5552": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Swedish,
        locationGpids: ["5216"],
    },
    "0": {
        weightGroupName: COLLECTION_FOCUS_GROUP_NAME.Usa,
        locationGpids: ["2"],
    },
};
